import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { DeleteIcon, Tooltip } from "@flat-ui";
import { DeleteGroupDialog } from "@pages/group-details/delete-group-dialog";
import { groupProjectsCountSelector } from "@store/groups/groups-selector";
import { useAppSelector } from "@store/store-helper";
import { PALETTE_VARS } from "@styles/palette-vars";
import { useState } from "react";

/** Explains the one way out of a group that still holds projects. */
const HAS_PROJECTS_TOOLTIP = "To delete a group please first move the existing projects to another group. " + 'You can do this by selecting all projects and clicking on "Management".';

/**
 * Deletes the group shown on the group details page, as long as no project is left in it.
 */
export function DeleteGroupButton(t0) {
  const $ = _c(14);
  const {
    group
  } = t0;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t1;
  if ($[0] !== group.id) {
    t1 = groupProjectsCountSelector(group.id);
    $[0] = group.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const projectsCount = useAppSelector(t1);
  const isDeletable = projectsCount === 0;
  const t2 = projectsCount ? HAS_PROJECTS_TOOLTIP : "Delete group";
  const t3 = !isDeletable;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsDialogOpen(true);
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t3) {
    t5 = <SphereIconButton component={DeleteIcon} buttonSize="40px" iconSize="24px" color={PALETTE_VARS.text.primary} isDisabled={t3} onClick={t4} dataTestId="DELETE_GROUP_BUTTON" />;
    $[3] = t3;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t2 || $[6] !== t5) {
    t6 = <Tooltip component="div" title={t2} placement="bottom-end">{t5}</Tooltip>;
    $[5] = t2;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== group || $[9] !== isDialogOpen) {
    t7 = isDialogOpen && <DeleteGroupDialog group={group} onClose={() => setIsDialogOpen(false)} />;
    $[8] = group;
    $[9] = isDialogOpen;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}